import { documentType, formatDocument, normalizeDocument } from 'utils/document'

const formatCpfCnpj = (value: string) => formatDocument(value)

export const getDocumentType = (document: string): 'CPF' | 'CNPJ' => {
  const type = documentType(document)
  if (type) return type

  // Fallback heurístico para entrada incompleta/inválida (mantém contrato não-nulo).
  return normalizeDocument(document).length <= 11 ? 'CPF' : 'CNPJ'
}

export default formatCpfCnpj
